import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  AvailabilityStatus,
  AvailabilityUpdateInfo,
  AvailableStatuses,
  MaterialTab,
} from 'app/entity/models/entity';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { RollupTabsContentCardHeaderComponent } from '../rollup-tabs-content-card-header/rollup-tabs-content-card-header.component';
import { Subscription } from 'rxjs';
import { DictionaryItem, DictionaryTypes } from 'app/models/dictionaries';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { Store } from '@ngrx/store';
import { ConfigurationLoader } from 'shared/configuration-loader';
import { DictionariesService } from 'app/services/dictionaries.service';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { RollUpTab } from 'app/entity/models/rollup-card';
import { rollupTabSelected } from 'app/entity/actions/entity.actions';
import { getSelectedRollupTab } from 'app/entity/reducers/entity.reducer';

@Component({
  selector: "app-rollup-tabs-card-header-rapido",
  templateUrl: "./rollup-tabs-card-header-rapido.component.html",
  styleUrls: ["./rollup-tabs-card-header-rapido.component.scss"],
})
export class RollupTabsCardHeaderRapidoComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit
{
  @Input() public fgId: string;
  @Input() public fgTitle: string;
  @Input() public materialTabs: MaterialTab[];
  @Input() public language: string;

  @ViewChild("nav", { read: DragScrollComponent })
  public dragScroll: DragScrollComponent;
  @ViewChildren("rollupTabsContentCardHeaderComponent")
  private rollupTabs: QueryList<RollupTabsContentCardHeaderComponent>;

  public availabilityStatuses = AvailabilityStatus;
  public availableStatuses = AvailableStatuses;
  public activeId: number;
  public subscriptions = new Subscription();
  private activeIdChanged = false;
  public formatByCode: DictionaryItem;
  public readonly arrowIconRight = faAngleRight;
  public readonly arrowIconLeft = faAngleLeft;

  public hasEcontentIssues: boolean[];

  public constructor(
    public readonly store: Store,
    public elementRef: ElementRef
  ) {}

  public moveLeft() {
    this.dragScroll.moveLeft();
  }

  public moveRight() {
    this.dragScroll.moveRight();
  }

  public showArrowButton() {
    const dragScrollContent = this.elementRef.nativeElement.querySelector(
      '.drag-scroll-content'
    );
    return dragScrollContent
      ? dragScrollContent.scrollWidth > dragScrollContent.clientWidth
      : false;
  }

  public ngOnInit(): void {
    this.selectRollupTab();
  }

  public ngAfterViewInit() {
    if (this.activeIdChanged) {
      this.dragScroll.moveTo(this.activeId);
      this.activeIdChanged = false;
    }

    // if material tab is set to active, set the active tab on the UI
    if (this.materialTabs && this.materialTabs.length) {
      const index = this.materialTabs.findIndex((p) => p.active);
      if (index > -1) {
        const tabEvent = {
          nextId: index,
        } as NgbNavChangeEvent;
        this.onTabChange(tabEvent);
      }
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.materialTabs?.currentValue?.length) {
      this.selectRollupTab();
    }
  }

  public selectRollupTab() {
    this.subscriptions.add(
      this.store
        .select(getSelectedRollupTab(this.fgId))
        .subscribe((selectedTab) => {
          let selectedTabIndex = selectedTab && selectedTab.selectedIndex;
          this.activeIdChanged = this.activeId !== selectedTabIndex;
          this.activeId = selectedTabIndex || 0;
        })
    );
  }

  public onTabChange(event: NgbNavChangeEvent) {
    const tabInfo: RollUpTab = {
      resourceId: this.fgId,
      tab: event.nextId,
    };
    this.store.dispatch(rollupTabSelected(tabInfo));
    this.dragScroll.moveTo(event.nextId);
  }

  public trackById(index: number, item: MaterialTab) {
    return item.name;
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
